module.exports = __webpack_public_path__ + "img/home-bg-POLAND.06e83b80.jpg";